/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersPresignedDownloadUrlResponseDto } from '../../models/users-presigned-download-url-response-dto';

export interface TenantsControllerGenerateCustomTemplateDownloadUrl$Params {

/**
 * Tenant name/slug for multi-tenancy isolation.
 */
  name: string;

/**
 * S3 key of the custom template to download
 */
  s3Key: string;
}

export function tenantsControllerGenerateCustomTemplateDownloadUrl(http: HttpClient, rootUrl: string, params: TenantsControllerGenerateCustomTemplateDownloadUrl$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersPresignedDownloadUrlResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerGenerateCustomTemplateDownloadUrl.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
    rb.query('s3Key', params.s3Key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersPresignedDownloadUrlResponseDto>;
    })
  );
}

tenantsControllerGenerateCustomTemplateDownloadUrl.PATH = '/o2-users/tenants/custom-templates/download-url/{name}';
